import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { trackInsiderM8SettingsPageBillingHistoryClick } from "@faire/web-api--source/events/insider/click/m8SettingsPageBillingHistory";
import { useCallback, useState } from "react";
/** Provides state and actions for showing and hiding the billing history modal. */ export function useShowBillingHistoryModal() {
    var _useState = _sliced_to_array(useState(false), 2), showBillingHistoryModal = _useState[0], setShowBillingHistoryModal = _useState[1];
    var toggleModal = useCallback(function() {
        return setShowBillingHistoryModal(function(current) {
            if (!current) {
                trackInsiderM8SettingsPageBillingHistoryClick();
            }
            return !current;
        });
    }, []);
    return {
        showBillingHistoryModal: showBillingHistoryModal,
        toggleModal: toggleModal
    };
}
